<!-- DESKTOP -->
<div *ngIf="!env.isMobile">
  <div class="table-header">
      <div class="float-left country-name box-6"></div>
      <div class="box-1 float-left lay text-center"><b>No</b></div>
      <div class="back box-1 float-left back text-center"><b>Yes</b></div>
      <div class="box-2 float-left"></div>
  </div>
  <div class="table-body">
    <div *ngFor="let item of fancyData; let i=index;trackBy:trackByIndex;">
      <div *ngIf="isInclude(tabVal, item?.sort_priority) && odds[item?.market_id]?.status == 1">
        <div [attr.data-title]="item?.susStatus" [ngClass]="item?.isSuspend ? 'suspended' : ''" class="fancy-tripple" *ngIf="isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE'">
          <div class="table-row">
            <div class="float-left country-name box-6" style="border-bottom: 0px;" (click)="fancyRunPosition(fancyPos, item)">
              <p class="m-b-0">
                <span>
                  <img class="img-fluid multi-star" src="https://speedcdn.io/assets/diamond-client-v8/star-red-inactive.png" *ngIf="isLogin() && !mmIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')">
                  <img class="img-fluid multi-star" src="https://speedcdn.io/assets/diamond-client-v8/star-red-active.png" *ngIf="isLogin() && mmIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')">
                  {{item.name}}
                </span>
              </p>
              <p class="m-b-0">
                <span class="mrkt-volume" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id]" [ngClass]="expo[item?.market_id][item?.selection_id]?.expose > 0 ? 'text-green' : 'text-red'">
                  {{fixedPostDecimal(expo[item?.market_id][item?.selection_id]?.expose)}}
                </span>
              </p>
            </div>
            
            <div class="custom-odds-new">
              <div class="con-boxes" *ngIf="odds[item?.market_id]?.active_rate == 1">
                <div class="{{odds[item?.market_id]?.lKey}} box-1 lay float-left text-center betting-disabled" (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'l3', 'fancy')">
                  <span class="odd d-block">{{odds[item?.market_id]?.lay_price ? odds[item?.market_id]?.lay_price : '-'}}</span>
                  <span class="d-block">{{odds[item?.market_id]?.lay_rate ? odds[item?.market_id]?.lay_rate : '-'}}</span>
                </div>
                <div class="{{odds[item?.market_id]?.bKey}} box-1 back float-left text-center betting-disabled lay" (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'b1', 'fancy')">
                  <span class="odd d-block">{{odds[item?.market_id]?.back_price ? odds[item?.market_id]?.back_price : '-'}}</span>
                  <span class="d-block">{{odds[item?.market_id]?.back_rate ? odds[item?.market_id]?.back_rate : '-'}}</span>
                </div>
              </div>
              <div class="con-boxes" *ngIf="odds[item?.market_id]?.active_rate1 == 1">
                <div class="{{odds[item?.market_id]?.lKey1}} box-1 lay float-left text-center betting-disabled" (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'l2', 'fancy')">
                  <span class="odd d-block">{{odds[item?.market_id]?.lay1_price ? odds[item?.market_id]?.lay1_price : '-'}}</span>
                  <span class="d-block">{{odds[item?.market_id]?.lay1_rate ? odds[item?.market_id]?.lay1_rate : '-'}}</span>
                </div>
                <div class="{{odds[item?.market_id]?.bKey1}} box-1 back float-left text-center betting-disabled lay" (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'b2', 'fancy')">
                  <span class="odd d-block">{{odds[item?.market_id]?.back1_price ? odds[item?.market_id]?.back1_price : '-'}}</span>
                  <span class="d-block">{{odds[item?.market_id]?.back1_rate ? odds[item?.market_id]?.back1_rate : '-'}}</span>
                </div>
              </div>
              <div class="con-boxes" *ngIf="odds[item?.market_id]?.active_rate2 == 1">
                <div class="{{odds[item?.market_id]?.lKey2}} box-1 lay float-left text-center betting-disabled" (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'l1', 'fancy')">
                  <span class="odd d-block">{{odds[item?.market_id]?.lay2_price ? odds[item?.market_id]?.lay2_price : '-'}}</span>
                  <span class="d-block">{{odds[item?.market_id]?.lay2_rate ? odds[item?.market_id]?.lay2_rate : '-'}}</span>
                </div>
                <div class="{{odds[item?.market_id]?.bKey2}} box-1 back float-left text-center betting-disabled lay" (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'b3', 'fancy')">
                  <span class="odd d-block">{{odds[item?.market_id]?.back2_price ? odds[item?.market_id]?.back2_price : '-'}}</span>
                  <span class="d-block">{{odds[item?.market_id]?.back2_rate ? odds[item?.market_id]?.back2_rate : '-'}}</span>
                </div>
              </div>
            </div>

            <div class="box-2 float-left text-right min-max" style="border-bottom: 0px;">
              <span class="d-block">Min: <span>{{kFormatter(odds[item?.market_id]?.min_bet - 0)}}</span></span> <span class="d-block">Max: <span>{{kFormatter(odds[item?.market_id]?.max_bet - 0)}}</span></span>
            </div>
          </div>
        </div>
        <div class="table-remark text-right remark" *ngIf="(isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE') && item.message != null && item.message != ''">
          <marquee>{{item.message}}</marquee>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- DESKTOP -->

<!-- MOBILE -->
<div *ngIf="env.isMobile">
  <div class="table-body">
    <div *ngFor="let item of fancyData; let i=index;trackBy:trackByIndex;">
      <div *ngIf="isInclude(tabVal, item?.sort_priority) && odds[item?.market_id]?.status == 1">
        <div class="fancy-tripple" *ngIf="isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE'">
          <div [attr.data-title]="item?.susStatus" [ngClass]="item?.isSuspend ? 'suspended' : ''" class="table-row">
              <div class="float-left country-name box-4" (click)="fancyRunPosition(fancyPos, item)">
                  <span>
                    <b>
                      <img class="img-fluid multi-star" src="https://speedcdn.io/assets/diamond-client-v8/star-red-inactive.png" *ngIf="isLogin() && !mmIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')">
                      <img class="img-fluid multi-star" src="https://speedcdn.io/assets/diamond-client-v8/star-red-active.png" *ngIf="isLogin() && mmIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')">
                      {{item.name}}
                    </b>
                    <em>
                      <span class="mrkt-volume float-left" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id]" [ngClass]="expo[item?.market_id][item?.selection_id]?.expose > 0 ? 'text-green' : 'text-red'">
                        {{fixedPostDecimal(expo[item?.market_id][item?.selection_id]?.expose)}}
                      </span>
                    </em>
                  </span>
                  <div class="info-block">
                      <a href="#min-max-info625{{i}}" data-bs-toggle="collapse" data-bs-target="" aria-expanded="false" class="info-icon collapsed"><i class="fas fa-info-circle m-l-10"></i></a>
                      <div id="min-max-info625{{i}}" class="min-max-info collapse">
                        <span><b>Min:</b>{{kFormatter(odds[item?.market_id]?.min_bet - 0)}}</span> <span><b>Max:</b>{{kFormatter(odds[item?.market_id]?.max_bet - 0)}}</span>
                      </div>
                  </div>
                  <!--<p class="m-0" (click)="fancyRunPosition(fancyPos, item)">
                       <span class="float-left" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id+'_expose']" [ngClass]="expo[item?.market_id][item?.selection_id+'_expose'] > 0 ? 'text-green' : 'text-red'">
                          {{expo[item?.market_id][item?.selection_id+'_expose']}}
                      </span>
                  </p> -->
              </div>
              <div class="custom-odds-new">
                <div class="con-boxes" *ngIf="odds[item?.market_id]?.active_rate == 1">
                  <div class="{{odds[item?.market_id]?.lKey}} box-1 lay float-left text-center">
                    <button (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'l3', 'fancy')">
                        <span class="odd d-block">{{odds[item?.market_id]?.lay_price ? odds[item?.market_id]?.lay_price : '-'}}</span>
                        <span class="d-block">{{odds[item?.market_id]?.lay_rate ? odds[item?.market_id]?.lay_rate : '-'}}</span>
                    </button>
                  </div>
                  <div class="{{odds[item?.market_id]?.bKey}} box-1 back float-left text-center">
                      <button (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'b1', 'fancy')">
                          <span class="odd d-block">{{odds[item?.market_id]?.back_price ? odds[item?.market_id]?.back_price : '-'}}</span>
                          <span class="d-block">{{odds[item?.market_id]?.back_rate ? odds[item?.market_id]?.back_rate : '-'}}</span>
                      </button>
                  </div>
                </div>
                <div class="con-boxes" *ngIf="odds[item?.market_id]?.active_rate1 == 1">
                  <div class="{{odds[item?.market_id]?.lKey1}} box-1 lay float-left text-center">
                    <button (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'l2', 'fancy')">
                        <span class="odd d-block">{{odds[item?.market_id]?.lay1_price ? odds[item?.market_id]?.lay1_price : '-'}}</span>
                        <span class="d-block">{{odds[item?.market_id]?.lay1_rate ? odds[item?.market_id]?.lay1_rate : '-'}}</span>
                    </button>
                  </div>
                  <div class="{{odds[item?.market_id]?.bKey1}} box-1 back float-left text-center">
                      <button (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'b2', 'fancy')">
                          <span class="odd d-block">{{odds[item?.market_id]?.back1_price ? odds[item?.market_id]?.back1_price : '-'}}</span>
                          <span class="d-block">{{odds[item?.market_id]?.back1_rate ? odds[item?.market_id]?.back1_rate : '-'}}</span>
                      </button>
                  </div>
                </div>
                <div class="con-boxes" *ngIf="odds[item?.market_id]?.active_rate2 == 1">
                  <div class="{{odds[item?.market_id]?.lKey2}} box-1 lay float-left text-center">
                    <button (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'l1', 'fancy')">
                        <span class="odd d-block">{{odds[item?.market_id]?.lay2_price ? odds[item?.market_id]?.lay2_price : '-'}}</span>
                        <span class="d-block">{{odds[item?.market_id]?.lay2_rate ? odds[item?.market_id]?.lay2_rate : '-'}}</span>
                    </button>
                  </div>
                  <div class="{{odds[item?.market_id]?.bKey2}} box-1 back float-left text-center">
                      <button (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'b3', 'fancy')">
                          <span class="odd d-block">{{odds[item?.market_id]?.back2_price ? odds[item?.market_id]?.back2_price : '-'}}</span>
                          <span class="d-block">{{odds[item?.market_id]?.back2_rate ? odds[item?.market_id]?.back2_rate : '-'}}</span>
                      </button>
                  </div>
                </div>
              </div>

            <!-- new betslip -->
            <div *ngIf="isOpenBetSlip(item)">
              <div *ngIf="env.isBetOpenEnv && betSlipData?.market_id == item?.market_id && betSlipData?.selection_id == item?.selection_id">
                  <app-m-bet-slip [data]="betSlipData" [exposLisDis]="expo" (updateData)="updateData.emit($event)" (changeExpo)="changeExpo.emit($event)" (closeBet)="closeBet.emit($event)"></app-m-bet-slip>
              </div>
            </div>
            <!-- new betslip -->
          </div>
        </div>

        <div class="table-remark text-right remark" *ngIf="isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE' && item.message != null && item.message != ''">
          <marquee>{{item.message}}</marquee>
        </div>
      </div>
    </div>
  </div>
  
</div>
<!-- MOBILE -->

<!-- fancy run-position -->
<ng-template #fancyPos>
  <div class="modal-header">
    <h4 class="modal-title mt-0">{{book_name}}</h4>
    <button type="button" class="close" style="position: relative;font-size: 25px;opacity: 1;" (click)="modalRef?.hide()">×</button>
  </div>
  <div class="modal-body">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"
      style="top: -13px;right: -8px;position: relative;font-size: 15px;opacity: 1;">
      <i class="fa fa-close"></i>
    </button>
    <div class="table-responsive">
      <table id="btDataTable" class="table table-bordered btDataTable mb-0" style="width:100%">
        <thead>
          <tr>
            <th>RUN</th>
            <th>POSITION</th>
          </tr>
        </thead>
        <tbody>
          <tr id="goto-{{item.key}}" *ngFor="let item of fancyRun;let i=index;trackBy:trackByIndex;">
            <td>{{item?.run}}</td>
            <td [ngClass]="(item?.expose>= 0) ? 'text-green' : 'text-red'">{{item?.expose}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
<!-- fancy run-position -->